import DatagridSelect from "../data-grid-select/data-grid-select";

export default {
  props: ["data", "fields", "field"],
  components: {
    DatagridSelect
  },
  data() {
    return {
      tableProps: {
        // settings for table
        sortMethod: this.sortMethod,
        highlightCurrentRow: false,
        stripe: false,
        size: "mini",
        border: true
      },
      paginationDef: {
        // settings for pagination
        pageSize: 5,
        pageSizes: [5, 10, 20, 30],
        currentPage: 1
      },
      isSelectActive: false,
      selectData: {
        property: "",
        type: "",
        source_id: "",
        row: {}
      },
      filteredFields: [],
      filteredFieldsValues: [],
      filteringData: {},
      filterInput: "",
      fieldTag: {},
      filterTags: [],
      selectedRows: []
    };
  },
  computed: {
    lastTagIndex() {
      return this.filterTags.length - 1;
    },
    filteredData() {
      const tags = this.filterTags;
      const tagsLength = tags.length;
      const tag = tags[tagsLength - 1];
      let filteredData;
      let fullData;

      if (!tagsLength) {
        this.filteringData = {};
        return this.data;
      }
      if (tagsLength === 1) fullData = this.data;
      if (tagsLength > 1)
        fullData = this.filteringData[tags[tagsLength - 2].name];

      switch (tag.type) {
        case "gray":
          filteredData = this.filterByValue(fullData, tag);
          break;
        case "danger":
          filteredData = this.filterByNotValue(fullData, tag);
          break;
        case "primary":
          filteredData = this.filterByKeyAndValue(fullData, tag);
          break;
      }
      this.filteringData[tags[tagsLength - 1].name] = [...filteredData];

      return filteredData;
    }
  },
  methods: {
    openBookForCurrent() {
      // function for openning book for current config
      const book = this.$store.state.interface.desktop.find(
        window => window.childComponent === "Book"
      );
      if (!book) {
        let options = {
          type: "Book",
          name: "desktop",
          sourcename: this.field.source_id
        };
        this.$store.commit("ADD_NEW_WINDOW", options);
      } else {
        this.$store.commit("SET_BOOK_STATE_PROP", {
          field: "id",
          data: this.field.source_id
        });
        this.$store.commit("SET_BOOK_STATE_PROP", {
          field: "datatype",
          data: null
        });
        this.$store.commit("SET_BOOK_STATE_PROP", {
          field: "openningNewBook",
          data: true
        });
      }
    },
    changeFields(values) {
      this.filteredFields = this.fields.filter(
        field => values.indexOf(field.title) > -1
      );
    },
    // datagrid-select functions
    closeSelectWindow() {
      this.isSelectActive = false;
    },
    saveSelectEditing(selected) {
      this.$emit("updateData", selected);
    },
    openDatagridSelect() {
      if (this.field.type === "has_many") return;
      this.selectData = {
        source_id: this.field.source_id,
        row: this.data,
        label: this.field.title,
        type: this.field.type,
        property: this.field.title,
        simple: true
      };
      this.isSelectActive = true;
    },
    // filtering functions
    handleAddTag(e) {
      const value = this.filterInput;
      const type = this.getTagType(value);
      let name;
      let tagName;
      if (!value || !type) return;
      if (e.key === "Enter" && !e.ctrlKey) return;

      if (
        value.indexOf(this.fieldTag.value) !== -1 &&
        (value.indexOf("!") !== -1 || value.indexOf("?") !== -1)
      ) {
        name = value.replace(this.fieldTag.value, this.fieldTag.field);
        if (value.indexOf("!") > -1) tagName = value.replace("!", " ! ");
        if (value.indexOf("?") > -1) tagName = value.replace("?", " ? ");
      } else {
        name = tagName = value;
      }

      this.filterTags.push({ name, type, tagName });
      this.filterInput = "";
    },
    handleDeleteTag(tag) {
      this.filterTags = this.filterTags.filter(item => item.name !== tag.name);
    },
    handleClearTags() {
      this.filterTags = [];
    },
    handleSelect(item) {
      this.fieldTag = item;
    },
    querySearch(queryString, cb) {
      const array = this.filteredFields.map(item => ({
        field: item.title,
        value: item.title
      }));
      const results = queryString
        ? array.filter(this.createFilter(queryString))
        : array;
      cb(results);
    },
    createFilter(queryString) {
      return link =>
        link.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1;
    },
    getTagType(filter) {
      // get tag type (? ! and other)
      if (filter.indexOf("?") === -1 && filter.indexOf("!") === -1) {
        return "gray";
      } else if (filter.indexOf("?") > 0 && filter.indexOf("!") === -1) {
        return "primary";
      } else if (filter.indexOf("?") === -1 && filter.indexOf("!") > -1) {
        return "danger";
      } else {
        return false;
      }
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    getFieldValues(prop, propValue) {
      // get field values (bool, complex types
      switch (propValue) {
        case false:
          return "Нет";
        case true:
          return "Да";
        case null:
          return "";
        default:
          return propValue;
      }
    },
    filterByValue(fullData, { name }) {
      // filter by value ('123' in input)
      return fullData.filter(item => {
        for (const prop in item) {
          const propValue = this.getFieldValues(prop, item[prop]);
          if (
            String(propValue)
              .toLowerCase()
              .indexOf(name.toLowerCase()) !== -1 ||
            String(prop)
              .toLowerCase()
              .indexOf(name.toLowerCase()) !== -1
          ) {
            return true;
          }
        }
        return false;
      });
    },
    filterByKeyAndValue(fullData, { name }) {
      // filter by key and value ('name:123' in input)
      const separatorIndex = name.indexOf("?");
      const filterField = name.slice(0, separatorIndex).toLowerCase();
      const filterValue = name.slice(separatorIndex + 1, name.length);
      return fullData.filter(item => {
        if (item[filterField] === undefined) return false;
        const current = this.getFieldValues(filterField, item[filterField]);
        return (
          String(current)
            .toLowerCase()
            .indexOf(filterValue.toLowerCase()) !== -1
        );
      });
    },
    filterByNotValue(fullData, { name }) {
      // filter by not value ('name!123' or '!123' in input)
      const separatorIndex = name.indexOf("!");
      if (separatorIndex === 0) {
        const filterValue = name.slice(1);
        return fullData.filter(item => {
          for (const prop in item) {
            const propValue = this.getFieldValues(prop, item[prop]);
            if (
              String(propValue)
                .toLowerCase()
                .indexOf(filterValue.toLowerCase()) !== -1 ||
              String(prop)
                .toLowerCase()
                .indexOf(filterValue.toLowerCase()) !== -1
            ) {
              return false;
            }
          }

          return true;
        });
      } else {
        const filterField = name.slice(0, separatorIndex).toLowerCase();
        const filterValue = name.slice(separatorIndex + 1, name.length);
        return fullData.filter(item => {
          if (item[filterField] === undefined) return false;
          const current = this.getFieldValues(filterField, item[filterField]);
          return (
            String(current)
              .toLowerCase()
              .indexOf(filterValue.toLowerCase()) === -1
          );
        });
      }
    },
    sortMethod(prop) {
      // sorting fn for table (in table props)
      return (a, b) => {
        let prev = this.getFieldValues(prop, a[prop]);
        let next = this.getFieldValues(prop, b[prop]);

        if (typeof prev === "string") prev = prev.toLowerCase();
        if (typeof next === "string") next = next.toLowerCase();

        if (prev > next) return 1;
        if (prev < next) return -1;
        return 0;
      };
    }
  },
  created() {
    this.filteredFields = this.fields.slice(0, 2);
    this.filteredFieldsValues = this.filteredFields.map(field => field.title);
  }
};
